export default "__VITE_ASSET__N8ZEt9sk__"